import { option } from 'fp-ts';
import { Option } from 'fp-ts/lib/Option';
import { ordNumber } from 'fp-ts/lib/Ord';

export const getOrElseZero = option.getOrElse(() => 0);

/**
 * Sums optional numbers, counting a missing value as zero rather than letting it
 * blank the result. Used for table totals, where a row rendering a dash must
 * still leave the column total readable (issue #76).
 */
export const sumOptionNumbers = (xs: readonly Option<number>[]): number =>
	xs.reduce((total, x) => total + getOrElseZero(x), 0);

/*
export function getGrossExposure(e: Exposure) {
	return getOrElseZero(e.long) + getOrElseZero(e.short);
}

export function getNetExposure(e: Exposure) {
	return getOrElseZero(e.long) - getOrElseZero(e.short);
}
*/

export const ordOptionNumber = option.getOrd(ordNumber);

export const toPercent = (x: number) => x * 100;
